import { ImageDetailModel } from './image.detail.model';
export class PagedImageDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: ImageDetailModel[] = [];
}
